import { createFileRoute } from '@tanstack/react-router'
import { MarketingCalendar } from '@/components/admin/marketing/proactive/MarketingCalendar'

// The marketing calendar (F-MKT-N1): Pakistani festivals, national days,
// food days, seasons and paydays, plus the owner's own moments.
export const Route = createFileRoute('/admin/marketing/calendar')({
  component: () => <MarketingCalendar />,
})
